require('./blocks/digest/digest');
require('./blocks/video-item.less');
require('./blocks/big-icon-link.less');
require('./blocks/big-link');
require('./blocks/catalog.less');
require('./blocks/mini-filter/mini-filter');
require('./blocks/label-select.less');
require('./blocks/seminar.less');
require('./blocks/pagination.less');
require('./blocks/reviews/reviews');
require('./blocks/review.less');
require('./blocks/seo-catalog.less');
require('./blocks/textblock.less');
require('./blocks/sem-teachers');
require('./blocks/sem-spec');

require('./blocks/seminar-list/seminar-list.js');
require('./plugins/jquery.loader/require.js');
require('./blocks/web-form/web-form.js');
require('./blocks/seminars-video/seminars-video');



// WEBPACK FOOTER //
// ./training_center.js